import { render } from "./VooFooter.vue?vue&type=template&id=e926f0fa&scoped=true"
import script from "./VooFooter.vue?vue&type=script&lang=js"
export * from "./VooFooter.vue?vue&type=script&lang=js"

import "./VooFooter.vue?vue&type=style&index=0&id=e926f0fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e926f0fa"]])

export default __exports__